import type { QueryClient } from '@tanstack/react-query';
import { companyResearchApi } from './api/companyResearch.api';

export const DOSSIER_CACHE_TIME = 10 * 60 * 1000;
export const researchListKey = ['company-research'] as const;
export const researchDetailKey = (id: string | null) => ['company-research', id] as const;

export function researchDetailOptions(id: string | null) {
  return {
    queryKey: researchDetailKey(id),
    queryFn: ({ signal }: { signal: AbortSignal }) => companyResearchApi.get(id!, signal),
    enabled: Boolean(id),
    staleTime: DOSSIER_CACHE_TIME,
    // TanStack starts garbage collection only after the last observer closes.
    gcTime: DOSSIER_CACHE_TIME,
  };
}

export function invalidateResearch(client: QueryClient, id?: string) {
  void client.invalidateQueries({ queryKey: researchListKey, exact: true });
  if (id) void client.invalidateQueries({ queryKey: researchDetailKey(id), exact: true });
}
